import { fromJS } from "immutable";
import {
  SET_COMPENSATION_ACTION,
  SET_COMPENSATION_NAME,
  SET_COMPENSATION_CHANNELS,
  SET_DAILY_CHAT_ACTIVITY,
  SET_COMPENSATION_TASK_DETAILS,
  SET_COMPENSATION_REWARD_PER_ACTION,
  SET_EDIT_COMPENSATION_RULE,
  CLEAR_EDIT_COMPENSATION_RULE
} from "../../actions/actionConstants";

const initialState = {
  compensationData: null,
  compensationName: null,
  compensationChannels: null,
  dailyChatActivity: null,
  compensationTaskDetails: null,
  editCompensationRule: null,
  isEditMode: false
};

const initialImmutableState = fromJS(initialState);

export default function compensationReducer(state = initialImmutableState, action = {}) {
  switch (action.type) {
    case SET_COMPENSATION_ACTION:
      return state.set("compensationData", fromJS(action.payload));
    case SET_COMPENSATION_NAME:
      return state.set("compensationName", fromJS(action.payload));
    case SET_COMPENSATION_CHANNELS:
      return state.set("compensationChannels", fromJS(action.payload));
    case SET_DAILY_CHAT_ACTIVITY:
      return state.set("dailyChatActivity", fromJS(action.payload));
    case SET_COMPENSATION_TASK_DETAILS:
      return state.set("compensationTaskDetails", fromJS(action.payload));
    case SET_COMPENSATION_REWARD_PER_ACTION:
      return state.set("compensationRewardPerAction", fromJS(action.payload));
    case SET_EDIT_COMPENSATION_RULE:
      return state
        .set("editCompensationRule", fromJS(action.payload))
        .set("isEditMode", true);
    case CLEAR_EDIT_COMPENSATION_RULE:
      return state
        .set("editCompensationRule", null)
        .set("isEditMode", false);
    default:
      return state;
  }
}
